import request from './request_service';
import UrlService from './url_service';
import AuthenticationService from './authentication_service'
class BusinessService {


    static getMerchants(data) {
        let options = Object();
        options.url = UrlService.BASE_PATH + "/api/v1/business/merchants";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getMerchantById(id) {
        let options = Object();
        options.url = UrlService.BASE_PATH + "/api/v1/business/merchant/"+id;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    static getEmailSetupByMerchantId(id) {
        let options = Object();
        options.url = UrlService.BASE_PATH + "/api/v1/business/email/setups/"+id;
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }

    

    static logoutUAuth() {
        let options = Object();
        options.url = UrlService.UAUTH_BASE_PATH + "/exit";
        options.params = null;
        options.authenticated = true;
        return request.get(options);
    }
    static paymentConfirmation(data) {
        let options = Object();
        options.url = UrlService.ECOMMERCE_BASE_URL + "/payment/confirmation";
        options.params = data;
        options.authenticated = true;
        return request.post(options);
    }
  

}

export default BusinessService;